
import { CDBInput, CDBBtn } from "cdbreact";
import { RiRefreshLine } from "react-icons/ri";
import { AiOutlineFileText } from "react-icons/ai";
import { MdAdd } from "react-icons/md";
import { FaUpload, FaFileAlt } from "react-icons/fa";
import Table from "../Table/Table";
import TableCustom from "../TableCustom/TableCustom";
import { ThemeProvider } from "@mui/material/styles";
import { Pagination } from "@mui/material";
import { mainTheme } from "../../themes/themes";
import Select from "react-select";

export const LargeCard = ({
  name,
  headers,
  loading,
  data,
  totalItems,
  setPressedButton,
  setPage,
  page,
  setChangePage,
  icon,
  customTable,
  setSearch,
  bulkLoad,
  cState,
  providerState,
  reportState,
  itemsPerPage,
  setItemsPerPage,
  colorPorcentage,
  customFilters,
  excelColumnFilters,
  setExcelColumnFilters,
  excelColumnSearchFilters,
  setExcelColumnSearchFilters,
  getExcelFilterOptions,
}) => {

  const itemsPerPageOptions = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 15, label: "15" },
    { value: 20, label: "20" },
    { value: 25, label: "25" },
  ];

  const newHeaders = [...headers];
  const stateEdit =
    newHeaders[newHeaders.length - 1] === "/reception";
  const stateDispatch = newHeaders[newHeaders.length - 1] === "/dispatch";
  const stateSkus = newHeaders[newHeaders.length - 1] === "/skus";
  const iconChange = newHeaders[newHeaders.length - 1] === "/providers";
  const statePurchases = newHeaders[newHeaders.length - 1] === "/purchases";
  const stateTypeArticles = newHeaders[newHeaders.length - 1] === "/article-types";
  const stateCategories = newHeaders[newHeaders.length - 1] === "/categories";

  if (stateEdit || stateSkus || statePurchases || iconChange || stateDispatch || stateTypeArticles || stateCategories) {
    newHeaders.pop();
  }

  return (
    <div className="card-bg w-100 wide border p-4">
      <div className="p-0 h-100 justify-content-between">
        <div className="d-flex justify-content-between align-items-center w-100 flex-wrap mb-3">
          <div className="d-flex align-items-center mb-2">
            <div className="p-1 bg-grey rounded-circle">
              <i className={icon}></i>
            </div>
            <h4 className="font-weight-bold text-dark h4 mb-0">{name}</h4>
          </div>
          {customFilters && (
            <div className="d-flex align-items-center mb-2">
              {customFilters}
            </div>
          )}
        </div>
        <div className="d-flex align-items-center justify-content-between filter">
          <CDBInput
            type="search"
            placeholder="Buscar"
            icon={<i className="fa fa-search"></i>}
            className="w-100"
            width="100%"
            id="search"
            indeterminate={false}
            background="white"
            onChange={(e) => setSearch(e.target.value)}
          />
          {bulkLoad && (
            <>
              <CDBBtn
                title="Carga masiva"
                size="large"
                className="p-2 btn"
                onClick={() => {
                  setPressedButton("bulkLoad");
                }}
              >
                <FaUpload size={"1.3em"} />
              </CDBBtn>
            </>
          )}
          {(stateSkus || stateDispatch || iconChange) && (
            <CDBBtn
              title={stateSkus ? "Reporte SKUS" : stateDispatch ? "Reporte de Despachos" : "Reporte Proveedores"}
              size="large"
              className="p-2 btn"
              onClick={() => {
                setPressedButton("monthlyReport");
              }}
            >
              <FaFileAlt size={"1.3em"} />
            </CDBBtn>
          )}
          {cState && !providerState && (
            <CDBBtn
              size="large"
              className="p-2 btn"
              onClick={() => {
                setPressedButton("create");
              }}
            >
              <MdAdd size={"1.3em"} />
            </CDBBtn>
          )}

          {reportState && (
            <CDBBtn
              size="large"
              className="p-2 btn"
              onClick={() => {
                setPressedButton("reports");
              }}
            >
              <AiOutlineFileText size={"1.3em"} />
            </CDBBtn>
          )}

          <CDBBtn
            size="large"
            className="p-2 btn"
            onClick={() => {
              setPressedButton("refresh");
            }}
          >
            <RiRefreshLine size={"1.3em"} />
          </CDBBtn>
        </div>
        {stateSkus && (totalItems > itemsPerPage || totalItems >= 5) ? (
          <div className="d-flex align-items-center justify-content-end" style={{ marginTop: "10px", marginBottom: "10px" }}>
            <label className="mr-2">Elementos por página:</label>
            <div style={{ marginRight: "8px" }}></div>
            <Select
              id="itemsPerPageTop"
              options={itemsPerPageOptions}
              value={itemsPerPageOptions.find((option) => option.value === itemsPerPage)}
              onChange={(selectedOption) =>
                setItemsPerPage(parseInt(selectedOption.value))
              }
            />
          </div>
        ) : null}
        {customTable ? (
          <TableCustom
            headers={newHeaders}
            loading={loading}
            data={data}
            setPressedButton={setPressedButton}
            stateEdit={stateEdit}
            statePurchases={statePurchases}
            stateSkus={stateSkus}
            cState={cState}
            providerState={providerState}
            itemsPerPage={itemsPerPage}
          />
        ) : (
          <Table
            headers={newHeaders}
            loading={loading}
            data={data}
            setPressedButton={setPressedButton}
            stateEdit={stateEdit}
            statePurchases={statePurchases}
            stateSkus={stateSkus}
            changeIcon={iconChange}
            cState={cState}
            providerState={providerState}
            itemsPerPage={itemsPerPage}
            stateDispatch={stateDispatch}
            colorPorcentage={colorPorcentage}
            excelColumnFilters={excelColumnFilters}
            setExcelColumnFilters={setExcelColumnFilters}
            excelColumnSearchFilters={excelColumnSearchFilters}
            setExcelColumnSearchFilters={setExcelColumnSearchFilters}
            getExcelFilterOptions={getExcelFilterOptions}
          />
        )}
        {!stateSkus && (totalItems > itemsPerPage || totalItems >= 5) ?  (
            <div className="d-flex align-items-center justify-content-end" style={{ marginTop: "10px" }}>
              <label className="mr-2">Elementos por página:</label>
              <div style={{ marginRight: "8px" }}></div>
              <Select
                id="itemsPerPage"
                options={itemsPerPageOptions}
                value={itemsPerPageOptions.find((option) => option.value === itemsPerPage)}
                onChange={(selectedOption) =>
                  setItemsPerPage(parseInt(selectedOption.value))
                }
              />
            </div>          
          ) : null}
        <ThemeProvider theme={mainTheme}>
          {totalItems > itemsPerPage ? (
            <Pagination
              count={Math.ceil(totalItems / itemsPerPage)}
              color="primary"
              className="mt-3 pagination"
              page={page}
              shape="rounded"
              onChange={(e, value) => {
                setChangePage(false)
                setPage(value);
              }}
            />
          ) : null}
        </ThemeProvider>
      </div>
    </div>
  );
};